import { FC } from 'react';
import BaseLayout from 'packages/main/components/Layouts/BaseLayout';
import PublicHeader from 'packages/lib/common-ui/public-header';

export const PublicLayout: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  return (
    <BaseLayout>
      <PublicHeader />
      <div style={{ flex: 1 }}>{children}</div>
    </BaseLayout>
  );
};

export default PublicLayout;
